module.exports = __webpack_public_path__ + "img/feature7.e5d537f.png";